<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>Booking item</mat-label>
    <mat-select id="booking-item" formControlName="bookingItem">
      @for (option of bookingItemNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label i18n>Booking options</mat-label>
    <mat-select id="booking-options" multiple formControlName="bookingOptions">
      @for (option of bookingOptionNames; track option) {
        <mat-option [value]="option.id" [title]="option.name">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label i18n>States</mat-label>
    <input matInput type="text" style="text-transform: uppercase" formControlName="stateNamesString">
  </mat-form-field>
  <!--
  <mat-form-field appearance="outline">
    <mat-label i18n>States</mat-label>
    <mat-select id="states" multiple formControlName="states">
      <mat-option *ngFor="let option of bookingStateNames" [value]="option.id">
        {{ option.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  -->
  <mat-form-field appearance="outline">
    <mat-label i18n>Metadata</mat-label>
    <mat-select id="metadata" multiple formControlName="metadata">
      @for (option of bookingMetadataNames; track option) {
        <mat-option [value]="option.id" [title]="option.name">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-container>
